<template>
	<div class="login-options">
		<button class="login-option-button button-blurred option-akkodis border-animation"
						@click="loginUserWithSSO(ssoLoginType.akka)">
			<img class="login-button-icon" src="@/common/assets/images/akkodis-option.webp" alt="akka">
			Sign in with Akkodis account
		</button>
		<button class="login-option-button button-blurred option-adecco border-animation"
						@click="loginUserWithSSO(ssoLoginType.adecco)">
			<img class="login-button-icon adecco-option" src="@/common/assets/images/adecco-option.svg" alt="adecco">
			Sign in with Adecco Group account
		</button>
		<button class="login-option-button button-blurred option-guest" @click="redirectTo('sign-in')">
			<img class="login-button-icon guest-option not-filled" src="@/common/assets/images/guest-option.svg" alt="guest">
			Sign in as a Guest
		</button>
		<div class="divider">
			<span class="login-informative informative-attribute">or if you don’t have an account</span>
		</div>
		<button class="login-option-button request-guest border-animation" @click="redirectTo('register')">
			Request a Guest Account
		</button>
		<span class="login-informative">Once approved by the DRC team, you will be granted a Guest account.</span>
	</div>
</template>

<script>
import {EventButton} from "@/common/configurations/event-bus";
import Vue from "vue";
import msal from "vue-msal";
import * as SERVICE from "@/common/services/common-request-service";
import {NOTIFICATION_TYPE} from "@/common/utils/constants";
import loginMixin from "@/common/mixins/login-mixin";
import * as STATISTIC_SERVICE from "@/common/services/statistic-service"

export default {
	name: "LoginOptions",
	mixins: [loginMixin],
	data() {
		return {
			ssoLoginType: {
				akka: "Akka",
				adecco: "Adecco"
			}
		}
	},
	mounted() {
		const activeDirectory = localStorage.getItem('attemptedLoginWith');
		const clientInfo = document.URL.search(/id_token/i);

		if (activeDirectory && clientInfo !== -1) {
			this.loginUserWithSSO(activeDirectory);
		}
	},
	methods: {
		createMsal(directory){
			const isAdecco = directory === this.ssoLoginType.adecco;
			const redirectUrl = window.location.origin;
			const baseScope = [
				"user.read",
				"User.Read",
				"profile",
				"email"
			];
			const scopes = isAdecco ? [...baseScope, "mailboxsettings.read", "calendars.readwrite",] : baseScope;
			const graphScope = ["user.read", "User.Read"];

			Vue.use(msal, {
				auth: {
					clientId: isAdecco ? process.env.VUE_APP_CLIENT_ID : process.env.VUE_APP_AKKA_CLIENT_ID,
					tenantId: isAdecco ?  process.env.VUE_APP_TENANT_ID : process.env.VUE_APP_AKKA_TENANT_ID,
					redirectUri: `${redirectUrl}/login`,
					postLogoutRedirectUri: process.env.VUE_APP_POST_LOGOUT_URL,
					scopes: graphScope,
					autoRefreshToken: true,
				},
				cache: {
					cacheLocation: "localStorage",
					storeAuthStateInCookie: false,
				},
				request: {
					scopes: scopes,
				},
				graph: {
					callAfterInit: false,
					endpoints: {
						profile: "/me",
					},
				},
			});
		},
		loginUserWithSSO(directory) {
			this.createMsal(directory);
			localStorage.setItem('attemptedLoginWith', directory);

			if (!this.$msal.isAuthenticated()) {
				this.$msal.signIn();
			} else {
				const email = this.$msal.data.user.userName;
				const name = this.$msal.data.user.name.replaceAll('.', ' ');

				SERVICE.login({username: email, fullName: name}, "SSO")
					.then((response) => {
						this.setJwt(response, true, directory);
						this.addLoginStatistic();
					})
					.catch((error) => {
						console.error("Login failed with error: ", error);
						this.errorResponseHandling(error);
					});
			}
		},
		addLoginStatistic() {
			const props = {
				action: STATISTIC_SERVICE.ACTIONS.COMMON.USER_LOGIN_SSO,
				comment: JSON.stringify({
					email: this.$store.getters.getUser.email,
					fullName: this.$store.getters.getUser.fullName
				}),
				user: {id: this.$store.getters.getUser.id}
			}
			STATISTIC_SERVICE.addDrcStatistic(props);
		},
		errorResponseHandling(error) {
			if (error.response !== undefined) {
				this.showNotification(`${this.$t('notifications.loginFailed')}`, NOTIFICATION_TYPE.ERROR);
			}
		},
		redirectTo(option) {
			EventButton.$emit('shrink')
			this.$router.push(`/${option}`)
		},
	}
}
</script>

<style lang="scss" scoped>
@import '@/common/assets/css/_variables.scss';

.login-options {
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 15px;

	.option-akkodis{
		padding-right: 3.4rem !important
	}

	.login-option-button {
		padding: 9px 13px;
		background: transparent;
		color: white;
		border: 1px solid #EBEBF52E;
		min-height: 42px;
		cursor: pointer;
		font-family: Roboto, serif;
		font-size: 14px;
		font-weight: 400;
		line-height: 0;
		text-align: center;
		max-width: 480px;
		width: 100%;
		min-width: 250px;

		@media (max-width: $mobile) {
			font-size: 15px;
			padding: 11px 15px;
			min-height: 50px;
		}

		.login-button-icon {
			margin-right: 8px;
			height: 27px;
			width: 26px;

			&.adecco-option {
				height: 25px;
				width: 25px;
			}

			&.guest-option {
				height: 22px;
				width: 15px;
			}
		}
	}

	.button-blurred {
		background: #EBEBF52E;
	}

	.option-akkodis:hover {
		background: $color-hover-button;
		color: black;
	}

	.option-adecco:hover {
		background: #DA291C;
	}

	.option-guest:hover {
		color: black;
		background: white;

		img {
			filter: brightness(0) saturate(100%) invert(0%) sepia(93%) saturate(0%) hue-rotate(235deg) brightness(103%) contrast(103%);
		}
	}

	.request-guest:hover {
		background: #EBEBF52E;
	}

	.border-animation {
		border-top: 1px solid #EBEBF52E;
		border-bottom: 1px solid #EBEBF52E;
		border-left: 1px solid #EBEBF52E;
		border-right: 1px solid #EBEBF52E;
	}

	.border-animation:hover {
		transition: border-left-color 0.2s ease-in, border-top-color 0.5s ease-in, border-right-color 0.8s ease-in, border-bottom-color 1.2s ease-in;
		border-left-color: white;
		border-right-color: white;
		border-top-color: white;
		border-bottom-color: white;
	}

	.divider {
		display: flex;
		align-items: center;
		text-align: center;
		margin: 0;
		width: 100%;
		max-width: 480px;
	}

	.divider::before,
	.divider::after {
		content: '';
		flex: 1;
		border-bottom: 1px solid #AEAEB2;
		margin: 0;
	}

	.divider::before {
		margin-right: 10px;
	}

	.divider::after {
		margin-left: 10px;
	}

	.login-informative {
		font-family: Roboto, serif;
		font-size: 11px;
		font-weight: 400;
		line-height: 18px;
		color: #AEAEB2;
		text-align: center;
		max-width: 480px;

		@media (max-width: $mobile) {
			font-size: 12px;
		}
	}
}

</style>
